import { CdkTrapFocus } from '@angular/cdk/a11y'

import {
  Component,
  EventEmitter,
  Output,
  Inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox'

import { MULTIPLE_SELECT_INPUT, Item } from '../multiple-select.component'

export type InputData = {
  fieldName: string
  items: Item[]
  matchOptions: readonly { value: string; label: string }[] | null
  matchMode: string | null
}

@Component({
  templateUrl: './multiple-select-control.component.html',
  styleUrls: ['./multiple-select-control.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatCheckbox, CdkTrapFocus, FormsModule],
})
export class MultipleSelectControlComponent {
  matchMode: string | null
  readonly fieldName: string
  items: Item[] = []
  selectAll = false
  disableSelectAll = false

  private query = ''
  get filteredItems(): Item[] {
    return this.items.filter((item) =>
      item.label.toLocaleLowerCase().includes(this.query.toLocaleLowerCase()),
    )
  }

  @Output() readonly changeMatchMode = new EventEmitter<string>()
  @Output() readonly closed = new EventEmitter<void>()
  @Output() readonly changeSelected = new EventEmitter<Item[]>()

  constructor(@Inject(MULTIPLE_SELECT_INPUT) public inputData: InputData) {
    this.matchMode = inputData.matchMode
    this.fieldName = inputData.fieldName.replace(/[：:]+$/, '')
    this.items = this.inputData.items.map((item) => ({ ...item }))
    this.selectAll = this.items.every((item) => item.checked)
    this.disableSelectAll = !this.items.every((item) => !item.notSelectable)
  }

  /** パネル内の条件を更新し、親が閉じるまで保持する値を通知する */
  onMatchModeChange(mode: string): void {
    this.matchMode = mode
    this.changeMatchMode.emit(mode)
  }

  onSelect(selected: Item, e: MatCheckboxChange): void {
    const item = this.items.find(
      (i) => (i.id || i.label) === (selected.id || selected.label),
    )
    if (!item) return
    item.checked = e.checked
    this.changeSelected.emit(this.items)
    this.changeSelectAllIfNeeded()
  }

  onSelectAll(e: MatCheckboxChange): void {
    this.selectAll = e.checked
    this.filteredItems.forEach((item) => (item.checked = e.checked))
    this.changeSelected.emit(this.items)
  }

  onSearch(query: string): void {
    this.query = query
    this.changeSelectAllIfNeeded()
  }

  private changeSelectAllIfNeeded(): void {
    if (!this.filteredItems.length) return
    if (this.filteredItems.every((i) => i.checked)) {
      this.selectAll = true
    } else if (this.filteredItems.some((i) => !i.checked)) {
      this.selectAll = false
    }
  }
}
